module.exports = __webpack_public_path__ + "img/Locke.060c65b2.png";